import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useNavigate, Link } from "react-router-dom";

const gamesSliderItems = [
  {
    img: "assets/images/Aviator.png",
    link: "https://bpexch.me/tp-studio/aviator"
  },
  {
    img: "assets/images/AviatorNew.png",
    link: "https://bpexch.me/tp-studio/aviatorx"
  },
  { img: "assets/images/casino2.jpeg", link: "/royal-star/900003" },
  { img: "assets/images/casino3.jpeg", link: "/royal-star/900003" },

  { img: "assets/images/casino4.jpeg", link: "/royal-star/900003" },
  { img: "assets/images/casino5.jpeg", link: "/world-casino" },
  { img: "assets/images/casino6.jpeg", link: "/world-casino" },
  { img: "assets/images/casino1.jpeg", link: "/royal-star/900002" },
  { img: "assets/images/casino7.jpeg", link: "/royal-star/900002" },
  { img: "assets/images/casino8.jpeg", link: "/royal-star/900002" },
  { img: "assets/images/casino9.jpeg", link: "/royal-star/900001" },
  { img: "assets/images/casino10.jpeg", link: "/royal-star/900014" },
  { img: "assets/images/casino11.jpeg", link: "/world-casino" }
];

export default function GamesSlider() {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,

    variableWidth: false,
    centerMode: false,
    autoplay: true,
    centerPadding: "0px",
    autoplaySpeed: 3000,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3
        }
      }
    ]
  };
  return (
    <div class="banner-slider">
      <style>{` 

@media (max-width: 768px) {
  .banner-slider. slick-slide {
    width: 100px;
  }

  .banner-slider .games-slider-wrapper .slick-list {
    margin-left: -5px;
    margin-right: -5px;
    margin-top: -4px;
  }

  .banner-slider .slick-slide img { 
    height: 120px;
    object-fit: cover;
   
  } 

  .banner-slider .banner-slider .slick-center img {
    transform: scale(1.2);
    transition: transform 0.3s ease;
  }
  .banner-slider .slider-wrapper {
    width: 100%;
    max-width: 100%;
  }
  
  .banner-slider .slick-slide {
    width: auto !important;
  }
  .banner-slider .slick-track {
    display: flex;
  }
  
}

 

 
  

`}</style>
      <Slider {...settings}>
        {gamesSliderItems.map((item, idx) => (
          <div className="item" key={idx}>
            <div className="slider-item-row">
              <Link to={item.link}>
                <img
                  src={item.img}
                  className="img-fluid"
                  alt={`slide-${idx}`}
                />
              </Link>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
}
